import React from 'react'
import { Route } from 'react-router-dom'

import LoginContainer from '../containers/Login'
import CatalogoContainer from '../containers/Catalogo'
import RegistrarUsuarioContainer from '../containers/RegistrarUsuario'
import ControlActividadModalContainer from '../containers/ControlActividadModal'
import ProveedoresContainer from '../containers/ProveedoresContainer'

export const routes = () => {
    return (
        <div>
            <Route path="/" exact component={CatalogoContainer} />
            <Route path="/Login/:idUsuario?/:token?/:idUsuarioToken?" component={LoginContainer} />
            <Route path="/Catalogo" component={CatalogoContainer} />
            <Route path="/RegistrarUsuario/:idUsuario?/:token?" component={RegistrarUsuarioContainer} />
            <Route path="/ControlActividadModal" component={ControlActividadModalContainer} />
            {<Route path="/Proveedores/:codigoProveedor?" component={ProveedoresContainer} />}
        </div>
    );
}